// extracted by mini-css-extract-plugin
export default {"root":"LoginForm_root__MSaZE","submit-button":"LoginForm_submit-button__U-gUN"};